import type { URI } from 'features/call/call-base/interfaces';

export const isSorenson = (list: URI[]): boolean => {
  if (!list || list.length < 1) {
    return false;
  }
  return list.some((uri) => /^sorenson$/i.test(uri.Network));
};
